import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { ShieldCheck } from "lucide-react";

export const POPIA_TITLE = "POPIA & Data Handling Disclaimer";

const SECTIONS = [
  {
    heading: "Information we collect",
    items: [
      "Identification: name, email, business registration number, contact details.",
      "Compliance documents: SARS Tax Clearance, B-BBEE certificate, COIDA Letter of Good Standing, Proof of Address, Business Profile.",
      "Opportunity activity: Tenders, RFQs, RFIs you post or respond to, and timestamps of those events.",
      "Notification activity: email delivery logs.",
    ],
  },
  {
    heading: "Why we process this information",
    body: "To facilitate procurement matchmaking between buyers and SMMEs, to verify supplier eligibility, to send opportunity and expiry notifications, and to maintain a compliant audit trail.",
  },
  {
    heading: "Your rights",
    body: "You may request access, correction, deletion, or portability of your personal information at any time by writing to support@assmangsmmeportal.com. You may lodge a complaint with the Information Regulator (South Africa) if you believe your rights have been infringed.",
  },
  {
    heading: "Security measures",
    body: "All transmissions are SSL-encrypted. Documents are stored in encrypted object storage and access is logged. We do not sell or rent your personal information to third parties.",
  },
];

export function PopiaContent() {
  return (
    <div className="text-sm text-slate-600 space-y-4 leading-relaxed" data-testid="popia-content">
      <p className="text-xs font-semibold uppercase tracking-wide text-[#00427A]">Legal Notice</p>
      <p>
        Assmang SMME Portal ("we", "us") operates as a Responsible Party under the Protection of
        Personal Information Act, 4 of 2013 ("POPIA").
      </p>
      {SECTIONS.map((s) => (
        <div key={s.heading}>
          <h4 className="font-semibold text-slate-900 mb-1">{s.heading}</h4>
          {s.body && <p>{s.body}</p>}
          {s.items && (
            <ul className="list-disc pl-5 space-y-1">
              {s.items.map((it) => <li key={it}>{it}</li>)}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export function PopiaDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-[#00427A]" /> {POPIA_TITLE}
          </DialogTitle>
        </DialogHeader>
        <PopiaContent />
      </DialogContent>
    </Dialog>
  );
}
